import React from 'react';

import {CapStudent, TankStudent, TeeStudent} from "./Characters";
import {place, units} from "./stage";

// Listed back to front, matching the layering of the original illustration.
const STUDENTS = [
    {id: 'tank', order: 1, viewBox: [0, 24, 114, 104], Character: TankStudent},
    {id: 'cap', order: 2, viewBox: [54, 28, 66, 108], Character: CapStudent},
    {id: 'tee', order: 0, viewBox: [-35, 32, 96, 98], Character: TeeStudent}
];

export default function ({scene, playId}) {
    return STUDENTS.map(({id, order, viewBox, Character}) => (
        <div
            key={id}
            className={`v2-student v2-student-${id}`}
            style={{
                ...place(viewBox[0], viewBox[1]),
                width: units(viewBox[2]),
                height: units(viewBox[3]),
                '--i': order
            }}
        >
            <div className='v2-student-pop' key={playId}>
                <div className='v2-student-action' key={scene}>
                    <div className='v2-student-idle'>
                        <Character/>
                    </div>
                </div>
            </div>
        </div>
    ));
}
